exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-4308a4fd]{max-width:600px\n}\n.errors-wrapper[data-v-4308a4fd]{color:red;background:#ffe6e6;margin:0 16px 10px;line-height:24px;border-radius:2px\n}\n.sent-message[data-v-4308a4fd]{background:#E2F3EA;line-height:30px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4308a4fd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/account/ForgotPassword.vue
// module id = 261
// module chunks = 0